define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/core/Key",
	"csi/table/Preferences"
], function(declare, _, Key, Preferences) {

	return declare(Preferences, {
		constructor: function() {
			this.addCustomOption("namesSettings", null, false, "EXN");
			this.addCustomOption("imageExportFormat", "");
		},

		_namesSettingsLoad: function(value, options, mapKey) {
			// summary: convert persisted value into runtime option value
			var obj = {};

			if (value) {
				_.each(value, function(name, key) {
					var dpkey = mapKey(key);
					if (dpkey) {
						obj[dpkey] = name;
					}
				});
			} else {
				// initialize attributes to the default
				_.each(options.attributeKeys, function(key) {
					var dpkey = mapKey(key);
					if (dpkey) {
						const {prefix} = new Key({dpkey});
						if (prefix) {
							obj[dpkey] = prefix;
						}
					}
				}, this);
			}

			return obj;
		},
	});
});